export { RelatedItemsCarousel } from './related-items-carousel';
